import en from './en'
import fr from './fr'
export const SUPPORTED_LANGUAGES = ['en', 'fr']
export const DEFAULT_LANGUAGE = 'en'
export const CONTENT = {en, fr}